import { render } from "./brand_create.vue?vue&type=template&id=4e2adf5e"
import script from "./brand_create.vue?vue&type=script&lang=js"
export * from "./brand_create.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__